module.exports = __webpack_public_path__ + "img/tarj3-1.dd885134.png";